import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { useActiveProjectCohort } from '../../hooks/useActiveProjectCohort';
import {
  Alert,
  AlertIcon,
  AlertBody,
} from '@lifeomic/chroma-react/components/Alert';
import { UserPlus } from '@lifeomic/chromicons';
import { Text } from '@lifeomic/chroma-react/components/Text';

const messages = defineMessages({
  alertLabel: {
    id: 'PatientCohortAssignmentAlert.',
    defaultMessage: 'You are adding this subject to the "{cohortName}" cohort',
  },
});

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

export type PatientCohortAssignmentAlertOwnProps = {
  isCreatingPatient: boolean;
};

export type PatientCohortAssignmentAlertProps =
  PatientCohortAssignmentAlertOwnProps;

const PatientCohortAssignmentAlert: React.FC<
  PatientCohortAssignmentAlertProps
> = props => {
  const { formatMessage } = useIntl();
  const [activeProjectCohort] = useActiveProjectCohort();

  if (!props.isCreatingPatient || !activeProjectCohort) return null;

  return (
    <Alert>
      <AlertIcon icon={UserPlus} />
      <AlertBody>
        <Text size="subbody">
          {formatMessage(messages.alertLabel, {
            cohortName: activeProjectCohort?.name || activeProjectCohort?.id,
          })}
        </Text>
      </AlertBody>
    </Alert>
  );
};

export default React.memo(PatientCohortAssignmentAlert);
